import { Component, OnDestroy } from '@angular/core'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { Subscription } from 'rxjs'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NavbarComponent } from '../navbar/navbar.component'
import { SidebarComponent } from '../sidebar/sidebar.component'

// Telas "expandidas" escondem o menu lateral pra ganhar largura — só a Torre de
// Monitoramento por enquanto. Um botão de voltar substitui a navegação do sidebar.
const ROTAS_LAYOUT_EXPANDIDO = ['monitoramento-os']

@Component({
  selector: 'base-template',
  imports: [RouterOutlet, NavbarComponent, SidebarComponent, MatIconModule, MatTooltipModule],
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss',
})
export class BaseComponent implements OnDestroy {
  constructor(private router: Router) {
    this.layoutExpandido = this.ehRotaExpandida(this.router.url)
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.layoutExpandido = this.ehRotaExpandida(event.urlAfterRedirects)
      }
    })
  }

  layoutExpandido: boolean
  private subscription: Subscription

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  voltar(): void {
    this.router.navigate(['/home'])
  }

  private ehRotaExpandida(url: string): boolean {
    return ROTAS_LAYOUT_EXPANDIDO.some((rota) => url.includes(rota))
  }
}
